export default "__VITE_ASSET__2621436d__"